"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var tfs_css_variables_1 = __importDefault(require("tfs.css-variables"));
exports.default = {
    navigation: {
        display: 'grid',
        position: 'relative',
        overflow: 'hidden',
        gridTemplateColumns: 'auto 1fr auto',
        gridTemplateRows: '3rem 0rem',
        msGridColumns: 'auto 1fr auto',
        msGridRows: '3rem 0rem',
        backgroundColor: tfs_css_variables_1.default.colorWhite,
        zIndex: 1,
        boxShadow: {
            x: 0,
            y: 2,
            blur: '5px',
            spread: 0,
            color: tfs_css_variables_1.default.colorGrayE,
        },
        '& > *': {
            padding: [0, '1.5rem'],
            height: '3rem',
        },
        '& > :nth-child(1)': {
            borderRight: "1px solid " + tfs_css_variables_1.default.colorGrayE,
        },
        '& > :nth-child(-n+3)': {
            borderBottom: "1px solid " + tfs_css_variables_1.default.colorGrayE,
        },
    },
    isOpen: {
        gridTemplateRows: '3rem',
        msGridRows: '3rem',
    },
};
//# sourceMappingURL=Navigationheader.styles.js.map